import _slicedToArray from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import { isJsonObject, typeofJsonValue } from "./json-typings";
import { base64decode } from "./base64";
import { LongType, ScalarType } from "./reflection-info";
import { PbLong, PbULong } from "./pb-long";
import { assert, assertFloat32, assertInt32, assertUInt32 } from "./assert";
import { reflectionLongConvert } from "./reflection-long-convert";
/**
 * Reads proto3 messages in canonical JSON format using reflection information.
 *
 * https://developers.google.com/protocol-buffers/docs/proto3#json
 */

export var ReflectionJsonReader = /*#__PURE__*/function () {
  function ReflectionJsonReader(info) {
    _classCallCheck(this, ReflectionJsonReader);

    this.info = info;
  }

  _createClass(ReflectionJsonReader, [{
    key: "prepare",
    value: function prepare() {
      var _a;

      if (this.fMap === undefined) {
        this.fMap = {};
        var fieldsInput = (_a = this.info.fields) !== null && _a !== void 0 ? _a : [];

        var _iterator = _createForOfIteratorHelper(fieldsInput),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var field = _step.value;
            this.fMap[field.name] = field;
            this.fMap[field.jsonName] = field;
            this.fMap[field.localName] = field;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    } // Cannot parse JSON <type of jsonValue> for <type name>#<fieldName>.

  }, {
    key: "assert",
    value: function assert(condition, fieldName, jsonValue) {
      if (!condition) {
        var what = typeofJsonValue(jsonValue);
        if (what == "number" || what == "boolean") what = jsonValue.toString();
        throw new Error("Cannot parse JSON ".concat(what, " for ").concat(this.info.typeName, "#").concat(fieldName));
      }
    }
    /**
     * Reads a message from canonical JSON format into the target message.
     *
     * Repeated fields are appended. Map entries are added, overwriting
     * existing keys.
     *
     * If a message field is already present, it will be merged with the
     * new data.
     */

  }, {
    key: "read",
    value: function read(input, message, options) {
      this.prepare();
      var oneofsHandled = [];

      for (var _i = 0, _Object$entries = Object.entries(input); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            jsonKey = _Object$entries$_i[0],
            jsonValue = _Object$entries$_i[1];

        var field = this.fMap[jsonKey];

        if (!field) {
          if (!options.ignoreUnknownFields) throw new Error("Found unknown field while reading ".concat(this.info.typeName, " from JSON format. JSON key: ").concat(jsonKey));
          continue;
        }

        var localName = field.localName; // handle oneof ADT

        var target = void 0; // this will be the target for the field value, whether it is member of a oneof or not

        if (field.oneof) {
          // since json objects are unordered by specification, it is not possible to take the last of multiple oneofs
          if (oneofsHandled.includes(field.oneof)) throw new Error("Multiple members of the oneof group \"".concat(field.oneof, "\" of ").concat(this.info.typeName, " are present in JSON."));
          oneofsHandled.push(field.oneof);
          target = message[field.oneof] = {
            oneofKind: localName
          };
        } else {
          target = message;
        } // we have handled oneof above. we just have read the value into `target`.


        if (field.kind == 'map') {
          if (jsonValue === null) {
            continue;
          } // check input


          this.assert(isJsonObject(jsonValue), field.name, jsonValue); // our target to put map entries into

          var fieldObj = target[localName]; // read entries

          for (var _i2 = 0, _Object$entries2 = Object.entries(jsonValue); _i2 < _Object$entries2.length; _i2++) {
            var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
                jsonObjKey = _Object$entries2$_i[0],
                jsonObjValue = _Object$entries2$_i[1];

            this.assert(jsonObjValue !== null, field.name + " map value", null); // read value

            var val = void 0;

            switch (field.V.kind) {
              case "message":
                val = field.V.T().internalJsonRead(jsonObjValue, options);
                break;

              case "enum":
                val = this.enum(field.V.T(), jsonObjValue, field.name, options.ignoreUnknownFields);
                if (val === false) continue;
                break;

              case "scalar":
                val = this.scalar(jsonObjValue, field.V.T, field.V.L, field.name);
                break;
            }

            this.assert(val !== undefined, field.name + " map value", jsonObjValue); // read key

            var key = jsonObjKey;
            if (field.K == ScalarType.BOOL) key = key == "true" ? true : key == "false" ? false : key;
            key = this.scalar(key, field.K, LongType.STRING, field.name).toString();
            fieldObj[key] = val;
          }
        } else if (field.repeat) {
          if (jsonValue === null) continue; // check input

          this.assert(Array.isArray(jsonValue), field.name, jsonValue); // our target to put array entries into

          var fieldArr = target[localName]; // read array entries

          var _iterator2 = _createForOfIteratorHelper(jsonValue),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var jsonItem = _step2.value;
              this.assert(jsonItem !== null, field.name, null);

              var _val = void 0;

              switch (field.kind) {
                case "message":
                  _val = field.T().internalJsonRead(jsonItem, options);
                  break;

                case "enum":
                  _val = this.enum(field.T(), jsonItem, field.name, options.ignoreUnknownFields);
                  if (_val === false) continue;
                  break;

                case "scalar":
                  _val = this.scalar(jsonItem, field.T, field.L, field.name);
                  break;
              }

              this.assert(_val !== undefined, field.name, jsonValue);
              fieldArr.push(_val);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        } else {
          switch (field.kind) {
            case "message":
              if (jsonValue === null && field.T().typeName != 'google.protobuf.Value') {
                this.assert(field.oneof === undefined, field.name + " (oneof member)", null);
                continue;
              }

              target[localName] = field.T().internalJsonRead(jsonValue, options, target[localName]);
              break;

            case "enum":
              var _val2 = this.enum(field.T(), jsonValue, field.name, options.ignoreUnknownFields);

              if (_val2 === false) continue;
              target[localName] = _val2;
              break;

            case "scalar":
              target[localName] = this.scalar(jsonValue, field.T, field.L, field.name);
              break;
          }
        }
      }
    }
    /**
     * Returns `false` for unrecognized string representations.
     *
     * google.protobuf.NullValue accepts only JSON `null`.
     */

  }, {
    key: "enum",
    value: function _enum(type, json, fieldName, ignoreUnknownFields) {
      if (type[0] == 'google.protobuf.NullValue') assert(json === null, "Unable to parse field ".concat(this.info.typeName, "#").concat(fieldName, ", enum ").concat(type[0], " only accepts null."));
      if (json === null) // we require 0 to be default value for all enums
        return 0;

      switch (typeof json) {
        case "number":
          assert(Number.isInteger(json), "Unable to parse field ".concat(this.info.typeName, "#").concat(fieldName, ", enum can only be integral number, got ").concat(json, "."));
          return json;

        case "string":
          var localEnumName = json;
          if (type[2] && json.substring(0, type[2].length) === type[2]) // lookup without the shared prefix
            localEnumName = json.substring(type[2].length);
          var enumNumber = type[1][localEnumName];

          if (typeof enumNumber === 'undefined' && ignoreUnknownFields) {
            return false;
          }

          assert(typeof enumNumber == "number", "Unable to parse field ".concat(this.info.typeName, "#").concat(fieldName, ", enum ").concat(type[0], " has no value for \"").concat(json, "\"."));
          return enumNumber;
      }

      assert(false, "Unable to parse field ".concat(this.info.typeName, "#").concat(fieldName, ", cannot parse enum value from ").concat(typeof json, "\"."));
    }
  }, {
    key: "scalar",
    value: function scalar(json, type, longType, fieldName) {
      var e;

      try {
        switch (type) {
          // float, double: JSON value will be a number or one of the special string values "NaN", "Infinity", and "-Infinity".
          // Either numbers or strings are accepted. Exponent notation is also accepted.
          case ScalarType.DOUBLE:
          case ScalarType.FLOAT:
            if (json === null) return .0;
            if (json === "NaN") return Number.NaN;
            if (json === "Infinity") return Number.POSITIVE_INFINITY;
            if (json === "-Infinity") return Number.NEGATIVE_INFINITY;

            if (json === "") {
              e = "empty string";
              break;
            }

            if (typeof json == "string" && json.trim().length !== json.length) {
              e = "extra whitespace";
              break;
            }

            if (typeof json != "string" && typeof json != "number") {
              break;
            }

            var float = Number(json);

            if (Number.isNaN(float)) {
              e = "not a number";
              break;
            }

            if (!Number.isFinite(float)) {
              // infinity and -infinity are handled by string representation above, so this is an error
              e = "too large or small";
              break;
            }

            if (type == ScalarType.FLOAT) assertFloat32(float);
            return float;
          // int32, fixed32, uint32: JSON value will be a decimal number. Either numbers or strings are accepted.

          case ScalarType.INT32:
          case ScalarType.FIXED32:
          case ScalarType.SFIXED32:
          case ScalarType.SINT32:
          case ScalarType.UINT32:
            if (json === null) return 0;
            var int32;
            if (typeof json == "number") int32 = json;else if (json === "") e = "empty string";else if (typeof json == "string") {
              if (json.trim().length !== json.length) e = "extra whitespace";else int32 = Number(json);
            }
            if (int32 === undefined) break;
            if (type == ScalarType.UINT32) assertUInt32(int32);else assertInt32(int32);
            return int32;
          // int64, fixed64, uint64: JSON value will be a decimal string. Either numbers or strings are accepted.

          case ScalarType.INT64:
          case ScalarType.SFIXED64:
          case ScalarType.SINT64:
            if (json === null) return reflectionLongConvert(PbLong.ZERO, longType);
            if (typeof json != "number" && typeof json != "string") break;
            return reflectionLongConvert(PbLong.from(json), longType);

          case ScalarType.FIXED64:
          case ScalarType.UINT64:
            if (json === null) return reflectionLongConvert(PbULong.ZERO, longType);
            if (typeof json != "number" && typeof json != "string") break;
            return reflectionLongConvert(PbULong.from(json), longType);
          // bool:

          case ScalarType.BOOL:
            if (json === null) return false;
            if (typeof json !== "boolean") break;
            return json;
          // string:

          case ScalarType.STRING:
            if (json === null) return "";

            if (typeof json !== "string") {
              e = "extra whitespace";
              break;
            }

            try {
              encodeURIComponent(json);
            } catch (e) {
              e = "invalid UTF8";
              break;
            }

            return json;
          // bytes: JSON value will be the data encoded as a string using standard base64 encoding with paddings.
          // Either standard or URL-safe base64 encoding with/without paddings are accepted.

          case ScalarType.BYTES:
            if (json === null || json === "") return new Uint8Array(0);
            if (typeof json !== 'string') break;
            return base64decode(json);
        }
      } catch (error) {
        e = error.message;
      }

      this.assert(false, fieldName + (e ? " - " + e : ""), json);
    }
  }]);

  return ReflectionJsonReader;
}();